import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  name: z.string().min(1, { message: msg.required }),
  year: z.coerce.number().min(1, { message: msg.required }),
  competition_type: z.coerce.number({ message: msg.required }),
  gender: z.enum(['M', 'F', 'B'], { message: msg.required }),
  age_categories: z.array(z.number()).min(1, { message: msg.required }),
  scoring_system: z.enum(['IPFGL', 'IPFGL_MALE', 'IPF', 'IPF_MALE', 'WILKS', 'WILKS_MALE', 'DOTS', 'DOTS_MALE'], {
    message: msg.required,
  }),
});

export type Schema = z.infer<typeof schema>;
